const MESSAGES = {
  TEST: {
    text: {
      EN: "I am MV {{BOAT_NAME}} on fire, fire is {{WHERE}} and my position is {{POSITION}} please send help",
      IT: "Sono la Motonave {{BOAT_NAME}} in fiamme, le fiamme si trovano {{WHERE}} e la mia posizione è {{POSITION}} mandate aiuto",
      FR: "Je suis le MV {{BOAT_NAME}} en feu, le feu est {{WHERE}} et ma position est {{POSITION}} veuillez envoyer de l'aide ",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
      {
        name: "WHERE",
        type: "SELECT",
        options: [
          {
            EN: "on deck",
            IT: "sul ponte",
            FR: "sur le pont",
          },
          {
            EN: "in engine-room",
            IT: "nella sala macchine",
            FR: "dans la salle des machines",
          },
          {
            EN: "in hold",
            IT: "nella stiva",
            FR: "dans la soute",
          },
          {
            EN: "in superstructure",
            IT: "nelle sovrastrutture",
            FR: "en superstructure",
          },
        ],
      },
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
  },
  CUSTOM: {
    text: {
      EN: "Custom text",
      IT: "Testo libero",
      FR: "Texte personnalisé",
    },
  },
  C1: {
    text: {
      EN: "MAY DAY",
      IT: "MAY DAY",
    },
    icon: "mayday",
    iconColor: "red",
  },
  C2: {
    text: {
      EN: "PAN PAN",
      IT: "PAN PAN",
    },
    icon: "panpan",
    iconColor: "red",
  },
  C3: {
    text: {
      EN: "SECURITE",
      IT: "SECURITE",
    },
    icon: "securite",
    iconColor: "orange",
  },
  "C1.1": {
    text: {
      EN: "Fire, explosion",
      IT: "Incendio, esplosione",
      FR: "Incendie / Explosion",
    },
    icon: "fire",
    iconColor: "red",
  },
  "C1.2": {
    text: {
      EN: "Search and rescue",
      IT: "Ricerca e soccorso",
      FR: "Chercher et sauver",
    },
    icon: "search and rescue_alt",
    iconColor: "red",
  },
  "C1.2.1": {
    text: {
      EN: "Communications",
      IT: "Comunicazioni",
      FR: "Communications",
    },
    icon: "communication",
    iconColor: "red",
  },
  "C1.2.2": {
    text: {
      EN: "Acknowledgement or relay",
      IT: "Acquisizione o rilancio",
      FR: "Acquittement ou relance",
    },
    icon: "ack_alt",
    iconColor: "red",
  },
  "C1.2.3": {
    text: {
      EN: "Coordination",
      IT: "Coordinamento",
      FR: "Coordination",
    },
    icon: "coordination",
    iconColor: "red",
  },
  "C1.2.4": {
    text: {
      EN: "Concluding operations",
      IT: "Conclusione operazioni",
      FR: "Opérations finales",
    },
    icon: "concluding operations",
    iconColor: "red",
  },
  "C1.2.5": {
    text: {
      EN: "Person overboard",
      IT: "Uomo in mare",
      FR: "Homme à la mer",
    },
    icon: "person_overboard_alt2",
    iconColor: "red",
  },

  "C2.1": {
    text: {
      EN: "Tug request",
      IT: "Richiesta di rimorchio",
      FR: "Demande de remorqueur",
    },
    icon: "tug request",
    iconColor: "red",
  },
  "C2.2": {
    text: {
      EN: "Technical failure",
      IT: "Avarie tecniche",
      FR: "Panne technique",
    },
    icon: "technical",
    iconColor: "red",
  },
  "C3.1": {
    text: {
      EN: "Navigational warnings",
      IT: "Pericoli della navigazione",
      FR: "Avertissements de navigation",
    },
    icon: "navigational warnings",
    iconColor: "orange",
  },
  "C3.2": {
    text: {
      EN: "Avoiding dangerous situations",
      IT: "Evitare situazioni di pericolo",
      FR: "Évitez les situations dangereuses",
    },
    icon: "avoiding",
    iconColor: "orange",
  },
  1.1: {
    text: {
      EN: "I am MV {{BOAT_NAME}} on fire",
      IT: "Sono la Motonave {{BOAT_NAME}} in fiamme",
      FR: "Je suis le MV {{BOAT_NAME}} en feu",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  "1.1a": {
    text: {
      EN: "I am MV {{BOAT_NAME}} after explosion",
      IT: "Sono la Motonave {{BOAT_NAME}} esplosa",
      FR: "Je suis le MV {{BOAT_NAME}} après l'explosion",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  1.2: {
    text: {
      EN: "Where is the fire?",
      IT: "Dove si trovano le fiamme?",
      FR: "Où est le feu ?",
    },
    answers: ["1.2.1"],
  },
  "1.2.1": {
    text: {
      EN: "Fire is {{WHERE}}",
      IT: "Le fiamme si trovano {{WHERE}}",
      FR: "Le feu est {{WHERE}}",
    },
    params: [
      {
        name: "WHERE",
        type: "SELECT",
        options: [
          {
            EN: "on deck",
            IT: "sul ponte",
            FR: "sur le pont",
          },
          {
            EN: "in engine-room",
            IT: "nella sala macchine",
            FR: "dans la salle des machines",
          },
          {
            EN: "in hold",
            IT: "nella stiva",
            FR: "en soute",
          },
          {
            EN: "in superstructure",
            IT: "nelle sovrastrutture",
            FR: "en superstructure",
          },
        ],
      },
    ],
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  1.3: {
    text: {
      EN: "Are dangerous goods on fire?",
      IT: "Ci sono merci pericolose in fiamme?",
      FR: "Des marchandises dangereuses sont-elles en feu ?",
    },
    answers: ["1.3.1", "1.3.2"],
  },
  "1.3.1": {
    text: {
      EN: "Yes, dangerous goods are on fire",
      IT: "Si ci sono merci pericolose in fiamme",
      FR: "Oui, des marchandises dangereuses sont en feu",
    },
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  "1.3.2": {
    text: {
      EN: "No, dangerous goods are not on fire",
      IT: "Non ci sono merci pericolose in fiamme",
      FR: "Non, les marchandises dangereuses ne sont pas en feu",
    },
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  1.4: {
    text: {
      EN: "Is there danger of explosion?",
      IT: "C'è pericolo d'esplosione?",
      FR: "Y a-t-il danger d'explosion ?",
    },
    answers: ["1.4.1", "1.4.2"],
  },
  "1.4.1": {
    text: {
      EN: "Yes, danger of explosion",
      IT: "Si c'è pericolo d'esplosione",
      FR: "Oui, danger d'explosion",
    },
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  "1.4.2": {
    text: {
      EN: "No danger of explosion",
      IT: "Non vi è pericolo d'esplosione",
      FR: "Pas de danger d'explosion",
    },
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  1.5: {
    text: {
      EN: "I am MV {{BOAT_NAME}} not under command",
      IT: "Sono la Motonave {{BOAT_NAME}} fuori governo",
      FR: "Je suis le MV {{BOAT_NAME}} hors de contrôle",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["1.7", "1.8"],
  },
  1.6: {
    text: {
      EN: "Is the fire under control?",
      IT: "Il fuoco è sotto controllo?",
      FR: "Le feu est-il maîtrisé ?",
    },
    answers: ["1.6.1", "1.6.2"],
  },
  "1.6.1": {
    text: {
      EN: "Yes, fire is under control",
      IT: "Si, il fuoco è sotto controllo",
      FR: "Oui, le feu est maîtrisé",
    },
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  "1.6.2": {
    text: {
      EN: "No, fire is not under control",
      IT: "No il fuoco non è sotto controllo",
      FR: "Non, le feu n'est pas maîtrisé",
    },
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  1.7: {
    text: {
      EN: "What kind of assistance is required?",
      IT: "Che tipo di assistenza richiedete?",
      FR: "Quel type d'assistance est nécessaire ?",
    },
    answers: ["1.7.1", "1.7.2"],
  },
  "1.7.1": {
    text: {
      EN: "MV {{BOAT_NAME}} does not require assistance",
      IT: "Motonave {{BOAT_NAME}} non richiede assistenza",
      FR: "Le MV {{BOAT_NAME}} ne nécessite pas d'assistance",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  "1.7.2": {
    text: {
      EN: "MV {{BOAT_NAME}} requires {{KIND}}",
      IT: "Motonave {{BOAT_NAME}} richiede {{KIND}}",
      FR: "Le MV {{BOAT_NAME}} nécessite {{KIND}}",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
      {
        name: "KIND",
        type: "SELECT",
        options: [
          {
            EN: "fire fighting assistance",
            IT: "assistenza antincendio",
            FR: "aide à la lutte contre l'incendie",
          },
          {
            EN: "breathing apparatus - smoke is toxic",
            IT: "apparati di respirazione - il fumo è tossico",
            FR: "appareil respiratoire - la fumée est toxique",
          },
          {
            EN: "foam extinguishers",
            IT: "estintori a schiuma",
            FR: "extincteurs à mousse",
          },
          {
            EN: "CO2 extinguishers",
            IT: "estintori a CO2",
            FR: "Extincteurs CO2",
          },
          {
            EN: "fire pumps",
            IT: "pompe antincendio",
            FR: "Pompes à incendie",
          },
          {
            EN: "medical assistance",
            IT: "assistenza medica",
            FR: "Assistance médicale",
          },
        ],
      },
    ],
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7", "1.8"],
  },
  1.8: {
    text: {
      EN: "Report injured persons",
      IT: "Riportate persone ferite",
      FR: "Signaler les blessés",
    },
    answers: ["1.8.1", "1.8.2"],
  },
  "1.8.1": {
    text: {
      EN: "No persons injured",
      IT: "Nessuna persona ferita",
      FR: "Aucune personne blessée",
    },
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7"],
  },
  "1.8.2": {
    text: {
      EN: "Number of injured persons: {{INJURED}}",
      IT: "Numero di persone ferite: {{INJURED}}",
      FR: "Nombre de blessés : {{INJURED}}",
    },
    params: [
      {
        name: "INJURED",
        type: "NUMBER",
        min: 0,
        max: 100,
      },
    ],
    answers: ["1.2", "1.3", "1.4", "1.6", "1.7"],
  },
  1.9: {
    text: {
      EN: "I am MV {{BOAT_NAME}} taking on water",
      IT: "Sono la Motonave {{BOAT_NAME}}: stiamo imbarcando acqua",
      FR: "Je suis le MV {{BOAT_NAME}}: nous prendons de l'eau",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
  },
  /*"1.10": {
    text: {
      EN: "I am MV {{BOAT_NAME}} reporting man overboard",
      IT: "Sono la Motonave {{BOAT_NAME}}: riportiamo uomo a mare",
      FR: "Je suis le MV {{BOAT_NAME}}: nous avons homme à la mer"
    },
	params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO"
      }
    ]
  },
  "1.11": {
    text: {
      EN: "I am MV {{BOAT_NAME}} with injured persons",
      IT: "Sono la Motonave {{BOAT_NAME}} con feriti a bordo",
      FR: "Je suis le MV {{BOAT_NAME}} avec blessés"
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO"
      }
    ]
  },*/
  2.1: {
    text: {
      EN: "MV {{BOAT_NAME}} requires assistance",
      IT: "Motonave {{BOAT_NAME}} richiede assistenza",
      FR: "Le MV {{BOAT_NAME}} a besoin d'aide",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.40",
    ],
  },
  2.2: {
    text: {
      EN: "I am MV {{BOAT_NAME}} proceeding to your assistance",
      IT: "Motonave {{BOAT_NAME}} sta procedendo in tua assistenza",
      FR: "Je suis le MV {{BOAT_NAME}} qui procède à votre assistance",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["2.4.1"],
  },
  "2.1.1": {
    text: {
      EN: "MV {{BOAT_NAME}} with injured on board",
      IT: "Motonave {{BOAT_NAME}} con feriti a bordo",
      FR: "MV {{BOAT_NAME}} avec blessé à bord",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.40",
    ],
  },
  2.3: {
    text: {
      EN: "What is your MMSI number?",
      IT: "Qual'è il tuo numero MMSI?",
      FR: "Quel est votre numéro MMSI ?",
    },
    answers: ["2.3.1"],
  },
  "2.3.1": {
    text: {
      EN: "My MMSI number is {{MMSI}}",
      IT: "Il mio numero MMSI è {{MMSI}}",
      FR: "Mon numéro MMSI est {{MMSI}}",
    },
    params: [
      {
        name: "MMSI",
        type: "BOAT_INFO",
      },
    ],
    // answers: ["2.2", "2.4", "2.5","2.6","2.6.2","2.7"]
    answers: [
      "2.2",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.40",
    ],
  },
  2.4: {
    text: {
      EN: "What is your position?",
      IT: "Qual'è la tua posizione?",
      FR: "Quelle est ta position?",
    },
    answers: ["2.4.1"],
  },
  "2.4.1": {
    text: {
      EN: "My position is {{POSITION}}",
      IT: "La mia posizione è {{POSITION}}",
      FR: "Ma position est {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    //answers: ["2.2", "2.3", "2.5","2.13","2.14","2.17.1","2.17.2","2.40"]
    answers: [
      "2.2",
      "2.3",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.40",
    ],
  },
  2.5: {
    text: {
      EN: "What is your present course and speed?",
      IT: "Qual'è la tua attuale rotta e velocità?",
      FR: "Quelle est votre course et votre vitesse actuelles ?",
    },
    answers: ["2.5.1"],
  },
  "2.5.1": {
    text: {
      EN: "My present course {{COURSE}} degrees, my speed {{SPEED}} knots",
      IT: "La mia attuale rotta {{COURSE}} gradi, la mia velocità è {{SPEED}} nodi",
      FR: "Mon cap actuel {{COURSE}} degrés, ma vitesse {{SPEED}} noeuds",
    },
    params: [
      {
        name: "COURSE",
        type: "TEXT",
      },
      {
        name: "SPEED",
        type: "SPEED",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.40",
    ],
  },
  2.6: {
    text: {
      EN: "Report number of persons on board",
      IT: "Riportare numero di persone a bordo",
      FR: "Déclarer le nombre de personnes à bord",
    },
    answers: ["2.6.1"],
  },
  "2.6.1": {
    text: {
      EN: "Number of persons on board: {{CREW_NUM}}",
      IT: "Numero di persone a bordo: {{CREW_NUM}}",
      FR: "Nombre de personnes à bord: {{CREW_NUM}}",
    },
    params: [
      {
        name: "CREW_NUM",
        type: "NUMBER",
        min: 0,
      },
    ],
    // answers: ["2.6.2"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.40",
    ],
  },
  "2.6.2": {
    text: {
      EN: "Report injured persons",
      IT: "Riportate persone ferite",
      FR: "Signaler les blessés",
    },
    answers: ["2.6.3", "2.6.4"],
  },
  "2.6.3": {
    text: {
      EN: "No persons injured",
      IT: "Nessuna persona ferita",
      FR: "Aucune personne blessée",
    },
    // answers: ["2.4","2.13"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.40",
    ],
  },
  "2.6.4": {
    text: {
      EN: "Number of injured persons: {{INJURED}}",
      IT: "Numero di persone ferite: {{INJURED}}",
      FR: "Nombre de blessés: {{INJURED}}",
    },
    params: [
      {
        name: "INJURED",
        type: "NUMBER",
        min: 0,
      },
    ],
    // answers: ["2.4","2.7","2.8","2.10","2.13","2.40"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.40",
    ],
  },
  2.7: {
    text: {
      EN: "Will you abandon vessel?",
      IT: "Abbandonerete la nave?",
      FR: "Abandonnerez-vous le navire ?",
    },
    answers: ["2.7.1", "2.7.2"],
  },
  "2.7.1": {
    text: {
      EN: "I will not abandon vessel",
      IT: "Non abbandoneremo la nave",
      FR: "Je n'abandonnerai pas le navire",
    },
    // answers: ["2.4","2.8","2.10"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.8",
      "2.10",
      "2.40",
    ],
  },
  "2.7.2": {
    text: {
      EN: "I will abandon vessel at {{HOUR}} UTC",
      IT: "Abbandoneremo la nave alle ore {{HOUR}} UTC",
      FR: "J'abandonnerai le navire à {{HOUR}} UTC",
    },
    params: [
      {
        name: "HOUR",
        type: "TEXT",
      },
    ],
    answers: ["2.2", "2.4", "2.8", "2.10", "2.11", "2.12", "2.17.2", "2.40"],
  },
  2.8: {
    text: {
      EN: "Is your EPIRB/SART transmitting?",
      IT: "La vosta EPIRB/SART sta trasmettendo?",
      FR: "Est-ce que votre EPIRB/SART transmet?",
    },
    answers: ["2.8.1", "2.8.2"],
  },
  "2.8.1": {
    text: {
      EN: "Yes, my EPIRB/SART is transmitting",
      IT: "Si, la mia EPIRB/SART sta trasmettendo",
      FR: "Oui, mon EPIRB/SART transmet",
    },
    // answers: ["2.10","2.11","2.17","2.17.1"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.10",
      "2.11",
      "2.17",
      "2.17.1",
      "2.40",
    ],
  },
  "2.8.2": {
    text: {
      EN: "Yes, my EPIRB/SART is transmitting by mistake",
      IT: "Si, la mia EPIRB/SART sta trasmettendo per errore",
      FR: "Oui, mon EPIRB/SART transmet par erreur",
    },
    // answers: ["2.10","2.17"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.10",
      "2.17",
      "2.40",
    ],
  },
  "2.10": {
    text: {
      EN: "Did you transmit a DSC distress alert?",
      IT: "Avete trasmesso un allarme in DSC?",
      FR: "Avez-vous transmis une alerte de détresse DSC?",
    },
    answers: ["2.10.1", "2.10.2"],
  },
  "2.10.1": {
    text: {
      EN: "Yes, I transmitted a DSC alert",
      IT: "Si ho trasmesso un allarme in DCS",
      FR: "Oui, j'ai transmis une alerte DSC",
    },
    // answers: ["2.17","2.17.1","2.11"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.17",
      "2.11",
      "2.17.1",
      "2.40",
    ],
  },
  "2.10.2": {
    text: {
      EN: "Yes, I transmitted a DSC alert by mistake",
      IT: "Si ho trasmesso un allarme in DCS per errore",
      FR: "Oui, j'ai transmis une alerte DSC par erreur",
    },
    // answers: ["2.17"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.17",
      "2.40",
    ],
  },
  2.11: {
    text: {
      EN: "How many lifeboats / liferafts (with how many persons) will you launch?",
      IT: "Quante scialuppe/zattere di salvataggio (con quante persone) calarete in acqua?",
      FR: "Combien de canots de sauvetage / radeaux de sauvetage (avec combien de personnes) lancerez-vous?",
    },
    answers: ["2.11.1"],
  },
  "2.11.1": {
    text: {
      EN: "I will launch {{LIFEBOAT_NUM}} {{RAFT_KIND}} (with {{PERSON_NUM}} persons)",
      IT: "Lancerò {{LIFEBOAT_NUM}} {{RAFT_KIND}} (con {{PERSON_NUM}} persone)",
      FR: "Je vais lancer {{LIFEBOAT_NUM}} {{RAFT_KIND}} (avec {{PERSON_NUM}} personnes)",
    },
    params: [
      {
        name: "LIFEBOAT_NUM",
        type: "NUMBER",
        min: 0,
      },
      {
        name: "RAFT_KIND",
        type: "SELECT",
        options: [
          {
            EN: "lifeboats",
            IT: "scialuppe",
            FR: "canots de sauvetage",
          },
          {
            EN: "liferafts",
            IT: "zattere di salvataggio",
            FR: "radeaux de sauvetage",
          },
        ],
      },
      {
        name: "PERSON_NUM",
        type: "NUMBER",
        min: 0,
      },
    ],
    // answers: ["2.12","2.40"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.12",
      "2.40",
    ],
  },
  2.12: {
    text: {
      EN: "How many people will stay on board?",
      IT: "Quante persone rimarranno a bordo?",
      FR: "Combien de personnes resteront à bord ?",
    },
    answers: ["2.12.1", "2.12.2"],
  },
  "2.12.1": {
    text: {
      EN: "No person will stay on board",
      IT: "Nessuna persona resterà a bordo",
      FR: "Personne ne restera à bord",
    },
    // answers: []
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.40",
    ],
  },
  "2.12.2": {
    text: {
      EN: "{{PERSON_ON_BOARD}} persons will stay on board",
      IT: "{{PERSON_ON_BOARD}} resteranno a bordo",
      FR: "{{PERSON_ON_BOARD}} personnes resteront à bord",
    },
    params: [
      {
        name: "PERSON_ON_BOARD",
        type: "NUMBER",
        min: 0,
      },
    ],
    // answers: ["2.13","2.14"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.14",
      "2.40",
    ],
  },
  2.13: {
    text: {
      EN: "What is the weather situation in your position?",
      IT: "Quali sono le condizioni meteo nella vostra posizione?",
      FR: "Quelle est la situation météorologique à votre poste?",
    },
    answers: ["2.13.1", "2.13.2", "2.13.3", "2.13.4"],
  },
  "2.13.1": {
    text: {
      EN: "Wind {{CARDINAL_POINTS}} force Beaufort {{WIND_FORCE}}",
      IT: "Vento {{CARDINAL_POINTS}} forza Beaufort {{WIND_FORCE}} ",
      FR: "Vent {{CARDINAL_POINTS}} force Beaufort {{WIND_FORCE}} ",
    },
    params: [
      {
        name: "CARDINAL_POINTS",
        type: "SELECT",
        options: [
          {
            EN: "N",
            IT: "N",
            FR: "N",
          },
          {
            EN: "NW",
            IT: "NO",
            FR: "NO",
          },
          {
            EN: "NE",
            IT: "NE",
            FR: "NE",
          },
          {
            EN: "S",
            IT: "S",
            FR: "S",
          },
          {
            EN: "SW",
            IT: "SO",
            FR: "SO",
          },
          {
            EN: "SE",
            IT: "SE",
            FR: "SE",
          },
          {
            EN: "W",
            IT: "O",
            FR: "O",
          },
          {
            EN: "E",
            IT: "E",
            FR: "",
          },
        ],
      },
      {
        name: "WIND_FORCE",
        type: "NUMBER",
        min: 0,
        max: 12,
      },
    ],
    // answers: ["2.17.1","2.13","2.14"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.17.1",
      "2.13",
      "2.14",
      "2.40",
    ],
  },
  "2.13.2": {
    text: {
      EN: "Visibility {{VISIBILITY}}",
      IT: "Visibilità {{VISIBILITY}}",
      FR: "Visibilité {{VISIBILITY}}",
    },
    params: [
      {
        name: "VISIBILITY",
        type: "SELECT",
        options: [
          {
            EN: "GOOD",
            IT: "BUONA",
            FR: "BIEN",
          },
          {
            EN: "MODERATE",
            IT: "DISCRETA",
            FR: "MODÉREE",
          },
          {
            EN: "POOR",
            IT: "SCARSA",
            FR: "LIMITÈE",
          },
        ],
      },
    ],
    // answers: ["2.17.1","2.13","2.14"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.14",
      "2.17.1",
      "2.40",
    ],
  },
  "2.13.3": {
    text: {
      EN: "{{SEA_CONDITION}} sea {{CARDINAL_POINTS}}",
      IT: "Mare {{SEA_CONDITION}} {{CARDINAL_POINTS}}",
      FR: "{{SEA_CONDITION}} mer {{CARDINAL_POINTS}}",
    },
    params: [
      {
        name: "SEA_CONDITION",
        type: "SELECT",
        options: [
          {
            EN: "SMOOTH",
            IT: "CALMO",
            FR: "LISSE",
          },
          {
            EN: "MODERATE",
            IT: "AGITATO",
            FR: "MODÉREE",
          },
          {
            EN: "ROUGH",
            IT: "MOLTO AGITATO",
            FR: "MER TRÈS FORTE GÊNANTE",
          },
          {
            EN: "HIGH",
            IT: "GROSSO",
            FR: "HAUT",
          },
        ],
      },
      {
        name: "CARDINAL_POINTS",
        type: "SELECT",
        options: [
          {
            EN: "N",
            IT: "N",
            FR: "N",
          },
          {
            EN: "NW",
            IT: "NO",
            FR: "NO",
          },
          {
            EN: "NE",
            IT: "NE",
            FR: "NE",
          },
          {
            EN: "S",
            IT: "S",
            FR: "S",
          },
          {
            EN: "SW",
            IT: "SO",
            FR: "SO",
          },
          {
            EN: "SE",
            IT: "SE",
            FR: "SE",
          },
          {
            EN: "W",
            IT: "O",
            FR: "O",
          },
          {
            EN: "E",
            IT: "E",
            FR: "E",
          },
        ],
      },
    ],
    // answers: ["2.17.1","2.13","2.14"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.14",
      "2.17.1",
      "2.40",
    ],
  },
  "2.13.4": {
    text: {
      EN: "Current {{CURRENT_KNOTS}} knots, to {{CARDINAL_POINTS}}",
      IT: "{{CURRENT_KNOTS}} nodi di Corrente verso {{CARDINAL_POINTS}}",
      FR: "{{CURRENT_KNOTS}} noeuds actuels, à {{CARDINAL_POINTS}}",
    },
    params: [
      {
        name: "CURRENT_KNOTS",
        type: "NUMBER",
      },
      {
        name: "CARDINAL_POINTS",
        type: "SELECT",
        options: [
          {
            EN: "N",
            IT: "N",
            FR: "N",
          },
          {
            EN: "NW",
            IT: "NO",
            FR: "NO",
          },
          {
            EN: "NE",
            IT: "NE",
            FR: "NE",
          },
          {
            EN: "S",
            IT: "S",
            FR: "S",
          },
          {
            EN: "SW",
            IT: "SO",
            FR: "SO",
          },
          {
            EN: "SE",
            IT: "SE",
            FR: "SE",
          },
          {
            EN: "W",
            IT: "O",
            FR: "O",
          },
          {
            EN: "E",
            IT: "E",
            FR: "E",
          },
        ],
      },
    ],
    // answers: ["2.17.1","2.13","2.14"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.14",
      "2.17.1",
      "2.40",
    ],
  },
  2.14: {
    text: {
      EN: "Are there dangers to navigation? ",
      IT: "Ci sono pericoli per la navigazione in zona?",
      FR: "Y a-t-il des dangers pour la navigation ?",
    },
    answers: ["2.14.1", "2.14.2"],
  },
  "2.14.1": {
    text: {
      EN: "No dangers to navigation",
      IT: "Nessun pericolo per la navigazione",
      FR: "Aucun danger pour la navigation",
    },
    // answers: ["2.17.1","2.13","2.17.2"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.2.17.2",
      "2.17.1",
      "2.40",
    ],
  },
  "2.14.2": {
    text: {
      EN: "Warning! {{CONCERN}}",
      IT: "Pericolo! {{CONCERN}}",
      FR: "Danger! {{CONCERN}}",
    },
    params: [
      {
        name: "CONCERN",
        type: "SELECT",
        options: [
          {
            EN: "UNCHARTED ROCKS",
            IT: "SCOGLI NON SEGNALATI",
            FR: "ROCHERS NON SIGNALE'",
          },
          {
            EN: "ICE",
            IT: "GHIACCIO",
            FR: "GLACE",
          },
          {
            EN: "ABNORMALLY LOW TIDES",
            IT: "ABNORME BASSA MAREA",
            FR: "MARÉES ANORMALEMENT BASSES",
          },
          {
            EN: "MINES",
            IT: "MINE",
            FR: "MINES",
          },
          {
            EN: "OTHER",
            IT: "ALTRO",
            FR: "AUTRE",
          },
        ],
      },
    ],
    // answers: ["2.17.1","2.13","2.17.2"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.17.2",
      "2.17.1",
      "2.40",
    ],
  },
  2.15: {
    text: {
      EN: "Received MAYDAY from MV {{MV_TO_SIGNAL}} at {{MAYDAY_HOUR}} UTC on VHF Channel {{CHANNEL}}",
      IT: "Ricevuto MAYDAY dalla Motonave {{MV_TO_SIGNAL}} alle ore {{MAYDAY_HOUR}} UTC sul canale {{CHANNEL}}",
      FR: "Reçu MAYDAY du MV {{MV_TO_SIGNAL}} à {{MAYDAY_HOUR}} UTC sur le canal VHF {{CHANNEL}}",
    },
    params: [
      {
        name: "MV_TO_SIGNAL",
        type: "TEXT",
      },
      {
        name: "MAYDAY_HOUR",
        type: "TEXT",
      },
      {
        name: "CHANNEL",
        type: "NUMBER",
        min: 1,
        max: 88,
      },
    ],
    answers: ["2.2", "2.17", "2.17.1"],
  },
  2.16: {
    text: {
      EN: "Vessel in position {{POSITION}} {{CONCERN}}",
      IT: "Nave in posizione  {{POSITION}} {{CONCERN}}",
      FR: "Navire en position {{POSITION}} {{CONCERN}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
      {
        name: "CONCERN",
        type: "SELECT",
        options: [
          {
            EN: "ON FIRE",
            IT: "IN FIAMME",
            FR: "EN FLAMMES",
          },
          {
            EN: "HAD EXPLOSION",
            IT: "CON ESPLOSIONE",
            FR: "AVEC EXPLOSION",
          },
          {
            EN: "FLOODED",
            IT: "ALLAGATA",
            FR: "INONDÉE",
          },
          {
            EN: "IN COLLISION",
            IT: "IN COLLISIONE",
            FR: "EN COLLISION",
          },
          {
            EN: "LISTING / IN DANGER OF CAPSIZING",
            IT: "INCLINATA / IN PERICOLO DI CAPOVOLGIMENTO",
            FR: "INSCRIPTION / EN DANGER DE CHAVIREMENT",
          },
          {
            EN: "SINKING",
            IT: "IN AFFONDAMENTO",
            FR: "NAUFRAGE",
          },
          {
            EN: "DISABLED AND ADRIFT",
            IT: "IN AVARIA ED ALLA DERIVA",
            FR: "EN PANNE ET À LA DÉRIVATION",
          },
          {
            EN: "ABANDONED",
            IT: "ABBANDONATA",
            FR: "ABANDONNÉE",
          },
        ],
      },
    ],
    answers: ["2.2", "2.17", "2.17.1", "2.17.2", "2.20", "2.21"],
  },
  2.17: {
    text: {
      EN: "Received your MAYDAY",
      IT: "Ricevuto il tuo MAYDAY",
      FR: "J'ai reçu votre MAYDAY",
    },
    answers: ["2.4.1", "2.20"],
  },
  "2.17.1": {
    text: {
      EN: "MV {{BOAT_NAME}} will proceed to your assistance",
      IT: "Motonave {{BOAT_NAME}} procederà in tua assistenza",
      FR: "Le MV {{BOAT_NAME}} procédera à votre assistance",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["2.1"],
  },
  "2.17.2": {
    text: {
      EN: "ETA at distress position AT {{TIME}} UTC",
      IT: "Tempo stimato di arrivo nella posizione di pericolo alle ore {{TIME}} UTC",
      FR: "ETA à la position de détresse À {{TIME}} UTC",
    },
    params: [
      {
        name: "TIME",
        type: "TEXT",
      },
    ],
    answers: ["2.1"],
  },
  2.18: {
    text: {
      EN: "I will act as On-scene Co-ordinator",
      IT: "Sarò l’OSC",
      FR: "J'agirai en tant que coordinateur sur place",
    },
    answers: [],
  },
  2.19: {
    text: {
      EN: "I will show following signals / lights: {{SIGNAL}}",
      IT: "Mostrerò I seguenti segnali/luci: {{SIGNAL}}",
      FR: "J'afficherai les signaux/lumières suivants: {{SIGNAL}}",
    },
    params: [
      {
        name: "SIGNAL",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  "2.20": {
    text: {
      EN: "Can you proceed to distress position?",
      IT: "Puoi procedere nella posizione di pericolo?",
      FR: "Pouvez-vous passer en position de détresse?",
    },
    answers: ["2.20.1", "2.20.2", "2.21", "2.21.1"],
  },
  "2.20.1": {
    text: {
      EN: "Yes, I can proceed to distress position",
      IT: "Si, posso procedere nella posizione di pericolo",
      FR: "Oui, je peux passer en position de détresse",
    },
    answers: ["2.20.3"],
  },
  "2.20.2": {
    text: {
      EN: "No, I cannot proceed to distress position",
      IT: "No, non posso procedere nella posizione di pericolo",
      FR: "Non, je ne peux pas passer en position de détresse",
    },
    answers: [],
  },
  "2.20.3": {
    text: {
      EN: "What is your ETA at distress position?",
      IT: "Qual’è il tempo stimato di arrivo nella posizione di pericolo?",
      FR: "Quelle est votre ETA en position de détresse?",
    },
    answers: ["2.20.4"],
  },
  "2.20.4": {
    text: {
      EN: "My ETA at distress position at {{MAYDAY_HOUR}} UTC",
      IT: "Il mio tempo stimato di arrivo nella posizione di pericolo è alle ore {{MAYDAY_HOUR}} UTC",
      FR: "Mon ETA à la position de détresse à {{MAYDAY_HOUR}} UTC",
    },
    params: [
      {
        name: "MAYDAY_HOUR",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  2.21: {
    text: {
      EN: "MAYDAY position is not correct",
      IT: "MAYDAY la posizione non è corretta",
      FR: "La position MAYDAY n'est pas correcte",
    },
    answers: ["2.21.1"],
  },
  "2.21.1": {
    text: {
      EN: "Correct MAYDAY position is {{POSITION}}",
      IT: "La posizione corretta del MAYDAY è {{POSITION}}",
      FR: "La position MAYDAY correcte est {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  2.22: {
    text: {
      EN: "Vessels are advised to proceed to position {{POSITION}} to start rescue",
      IT: "Le navi sono avvisate di procedere in posizione {{POSITION}} per iniziare le ricerche",
      FR: "Il est conseillé aux navires de se diriger vers la position {{POSITION}} pour commencer le sauvetage",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  2.23: {
    text: {
      EN: "Carry out search pattern {{SEARCH_PATTERN}} starting at {{HOUR}} UTC",
      IT: "Condurre lo schema di ricerca {{SEARCH_PATTERN}} iniziando alle ore {{HOUR}} UTC",
      FR: "Exécuter le modèle de recherche {{SEARCH_PATTERN}} à partir de {{HOUR}} UTC",
    },
    params: [
      {
        name: "SEARCH_PATTERN",
        type: "TEXT",
      },
      {
        name: "HOUR",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  2.24: {
    text: {
      EN: "Initial course {{DEGREES}} degrees, search speed {{SPEED}} knots",
      IT: "Rotta iniziale {{DEGREES}} gradi, velocità di ricerca {{SPEED}} nodi",
      FR: "Cap initial {{DEGREES}} degrés, vitesse de recherche {{SPEED}} noeuds",
    },
    params: [
      {
        name: "DEGREES",
        type: "TEXT",
      },
      {
        name: "SPEED",
        type: "SPEED",
      },
    ],
    answers: [],
  },
  2.25: {
    text: {
      EN: "Carry out radar search",
      IT: "Condurre ricerche al radar",
      FR: "Effectuer une recherche radar",
    },
    answers: [],
  },
  2.26: {
    text: {
      EN: "MV {{MV}} allocated track {{TRACK_NUMBER}}",
      IT: "Motonave {{MV}} assegnato percorso numero {{TRACK_NUMBER}}",
      FR: "MV {{MV}} piste allouée {{TRACK_NUMBER}}",
    },
    params: [
      {
        name: "MV",
        type: "TEXT",
      },
      {
        name: "TRACK_NUMBER",
        type: "NUMBER",
      },
    ],
    answers: [],
  },
  2.27: {
    text: {
      EN: "MV {{MV}} adjust interval between vessels to {{KILOMETERS}} kilometers",
      IT: "Motonave/motonavi {{MV}} si posizionino con intervallo di distanza {{KILOMETERS}} Km",
      FR: "MV {{MV}} ajuste l'intervalle entre les navires à {{KILOMETERS}} kilomètres",
    },
    params: [
      {
        name: "MV",
        type: "TEXT",
      },
      {
        name: "KILOMETERS",
        type: "NUMBER",
        min: 0,
      },
    ],
    answers: [],
  },
  2.28: {
    text: {
      EN: "MV {{MV}} Adjust track spacing to {{KILOMETERS}} kilometers",
      IT: "Motonave/motonavi {{MV}} si posizionino con rotte di distanza {{KILOMETERS}} Km",
      FR: "MV {{MV}} Ajuster l'espacement des pistes à {{KILOMETERS}} kilomètres",
    },
    params: [
      {
        name: "MV",
        type: "TEXT",
      },
      {
        name: "KILOMETERS",
        type: "NUMBER",
        min: 0,
      },
    ],
    answers: [],
  },
  2.29: {
    text: {
      EN: "Search speed now {{SPEED}} knots.",
      IT: "La velocità di ricerca adesso è {{SPEED}} nodi",
      FR: "Vitesse de recherche maintenant {{SPEED}} noeuds.",
    },
    params: [
      {
        name: "SPEED",
        type: "SPEED",
      },
    ],
    answers: [],
  },
  "2.30": {
    text: {
      EN: "Alter course to {{DEGREES}} degrees (at {{HOUR}} UTC)",
      IT: "Cambiare rotta di {{DEGREES}} gradi (alle ore {{HOUR}} UTC)",
      FR: "Modifier le cap à {{DEGREES}} degrés (à {{HOUR}} UTC)",
    },
    params: [
      {
        name: "DEGREES",
        type: "TEXT",
      },
      {
        name: "HOUR",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  2.31: {
    text: {
      EN: "Alter course for next leg of track now / at {{HOUR}} UTC",
      IT: "Cambiare rotta per il prossimo segmento di tracciato adesso/alle ore {{HOUR}} UTC",
      FR: "Changez de cap pour la prochaine étape de la piste maintenant / à {{HOUR}} UTC",
    },
    params: [
      {
        name: "HOUR",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  2.32: {
    text: {
      EN: "We resume search in position {{POSITION}}",
      IT: "Riprendiamo le ricerche in posizione {{POSITION}}",
      FR: "Nous reprenons la recherche en position {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  2.33: {
    text: {
      EN: "Crew has abandoned vessel / MV {{VESSEL}}",
      IT: "L’equipaggio ha abbandonato la nave {{VESSEL}}",
      FR: "L'équipage a abandonné le navire / MV {{VESSEL}}",
    },
    params: [
      {
        name: "VESSEL",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  2.34: {
    text: {
      EN: "What is the result of search?",
      IT: "Qual'è il risultato della ricerca?",
      FR: "Quel est le résultat de la recherche?",
    },
    answers: ["2.34.1", "2.34.2"],
  },
  "2.34.1": {
    text: {
      EN: "The result of search is negative",
      IT: "Il risultato della ricerca è negativo",
      FR: "Le résultat de la recherche est négatif",
    },
    answers: [],
  },
  "2.34.2": {
    text: {
      EN: "Sighted {{CONCERN}} in position {{POSITION}}",
      IT: "Avvistato {{CONCERN}} in posizione {{POSITION}}",
      FR: "A aperçu {{CONCERN}} en position {{POSITION}}",
    },
    params: [
      {
        name: "CONCERN",
        type: "SELECT",
        options: [
          {
            EN: "VESSEL",
            IT: "NAVE",
            FR: "NAVIRE",
          },
          {
            EN: "LIFEBOAT/LIFERAFT",
            IT: "SCIALUPPA/ZATTERA",
            FR: "CANOT DE SAUVETAGE/RADEAU DE SAUVETAGE",
          },
          {
            EN: "PERSONS IN WATER",
            IT: "PERSONA/E IN ACQUA",
            FR: "PERSONNES DANS L'EAU",
          },
        ],
      },
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  2.35: {
    text: {
      EN: "Keep sharp lookout for lifeboats / liferafts / persons in water!",
      IT: "Fare attenzione ad avvistare scialuppe/zattere/persone in acqua!",
      FR: "Faites attention aux canots de sauvetage / radeaux de sauvetage / personnes dans l'eau!",
    },
    answers: [],
  },
  2.36: {
    text: {
      EN: "Continue search in position {{POSITION}}",
      IT: "Continuate le ricerche in posizione {{POSITION}}",
      FR: "Continuer la recherche en position {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  2.37: {
    text: {
      EN: "Can you pick up survivors?",
      IT: "Potete recuperare i superstiti?",
      FR: "Pouvez-vous récupérer des survivants?",
    },
    answers: ["2.37.1", "2.37.2", "2.37.3", "2.37.4"],
  },
  "2.37.1": {
    text: {
      EN: "Yes, i can pick up survivors",
      IT: "Si, posso recuperare i superstiti",
      FR: "Oui, je peux récupérer des survivants",
    },
    answers: [],
  },
  "2.37.2": {
    text: {
      EN: "No, I cannot pick up survivors",
      IT: "No, non posso recuperare i superstiti",
      FR: "Non, je ne peux pas récupérer les survivants",
    },
    answers: [],
  },
  "2.37.3": {
    text: {
      EN: "MV {{BOAT_NAME}} will proceed to pick up survivors",
      IT: "Motonave {{BOAT_NAME}} procederà a recuperare i supertiti",
      FR: "MV {{BOAT_NAME}} va procéder à la récupération des survivants",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: [],
  },
  "2.37.4": {
    text: {
      EN: "Stand by lifeboats / liferafts",
      IT: "Pronte scialuppe/zattere",
      FR: "Stand by canots de sauvetage / radeaux de sauvetage",
    },
    answers: [],
  },
  2.38: {
    text: {
      EN: "Picked up {{NUMBER}} {{CONCERN}} in position {{POSITION}}",
      IT: "Recuperati {{NUMBER}} {{CONCERN}} in posizione {{POSITION}}",
      FR: "A récupéré {{NUMBER}} {{CONCERN}} en position {{POSITION}}",
    },
    params: [
      {
        name: "NUMBER",
        type: "NUMBER",
        min: 0,
      },
      {
        name: "CONCERN",
        type: "SELECT",
        options: [
          {
            EN: "SURVIVORS",
            IT: "SOPRAVVISSUTI",
            FR: "SURVIVANTS",
          },
          {
            EN: "PERSONS/ CASUALTIES IN LIFEJACKETS",
            IT: "PERSONE/ DECEDUTI CON GIUBBOTTI DI SALVATAGGIO",
            FR: "PERSONNES/VICTIMES EN GILETS DE SAUVETAGE",
          },
          {
            EN: "OBJECT",
            IT: "OGGETTO",
            FR: "OBJET",
          },
        ],
      },
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: ["2.41"],
  },
  "2.38.1": {
    text: {
      EN: "Picked up {{NUMBER}} lifebots/liferafts (with {{NUMBER2}} persons/casualties) in position {{POSITION}}",
      IT: "Recuperate {{NUMBER}} scialuppe/zattere (con {{NUMBER2}} persone/deceduti) in posizione {{POSITION}}",
      FR: "Ramassé {{NUMBER}} canots de sauvetage/radeaux de sauvetage (avec {{NUMBER 2}} personnes/victimes) en position {{POSITION}}",
    },
    params: [
      {
        name: "NUMBER",
        type: "NUMBER",
        min: 0,
      },
      {
        name: "NUMBER2",
        type: "NUMBER",
        min: 0,
      },
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: ["2.41"],
  },
  2.39: {
    text: {
      EN: "Survivors in {{CONDITION}} condition",
      IT: "Naufrago in {{CONDITION}} condizione",
      FR: "Survivants dans un état {{CONDITION}}",
    },
    params: [
      {
        name: "CONDITION",
        type: "SELECT",
        options: [
          {
            EN: "GOOD",
            IT: "BUONA",
            FR: "BIEN",
          },
          {
            EN: "BAD",
            IT: "CATTIVA",
            FR: "MAL",
          },
        ],
      },
    ],
    answers: ["2.40", "2.41"],
  },
  "2.40": {
    text: {
      EN: "Do you require medical assistance?",
      IT: "Richiedete assistenza medica?",
      FR: "Avez-vous besoin d'une assistance médicale?",
    },
    answers: ["2.40.1", "2.40.2"],
  },
  "2.40.1": {
    text: {
      EN: "Yes, I require medical assistance",
      IT: "Si, richiedo assistenza medica",
      FR: "Oui, j'ai besoin d'une assistance médicale",
    },
    // answers: ["2.2","2.49"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.14",
      "2.17.1",
      "2.40",
      "2.49",
    ],
  },
  "2.40.2": {
    text: {
      EN: "No, I do not require medical assistance",
      IT: "No, non richiedo assistenza medica",
      FR: "Non, je n'ai pas besoin d'assistance médicale",
    },
    // answers: ["2.2","2.49"]
    answers: [
      "2.2",
      "2.3",
      "2.4",
      "2.5",
      "2.6",
      "2.6.2",
      "2.7",
      "2.8",
      "2.10",
      "2.13",
      "2.14",
      "2.17.1",
      "2.40",
      "2.49",
    ],
  },
  2.41: {
    text: {
      EN: "Try to obtain information from survivors",
      IT: "Provate ad ottenere informazioni dal naufrago",
      FR: "Essayez d'obtenir des informations auprès des survivants",
    },
    answers: ["2.42", "2.43", "2.44", "2.45", "2.46", "2.48"],
  },
  2.42: {
    text: {
      EN: "There are still {{NUMBER}} lifeboats / liferafts with survivors",
      IT: "Ci sono ancora {{NUMBER}} scialuppe/zattere con superstiti",
      FR: "Il y a encore {{NUMBER}} canots de sauvetage / radeaux de sauvetage avec des survivants",
    },
    params: [
      {
        name: "NUMBER",
        type: "NUMBER",
        min: 0,
      },
    ],
    // answers: ["2.41","2.49"]
    answers: ["2.2", "2.41", "2.49"],
  },
  2.43: {
    text: {
      EN: "There are no more lifeboats / liferafts",
      IT: "Non c'è nessun altra scialuppa/zattera con superstiti",
      FR: "Il n'y a plus de canots de sauvetage / radeaux de sauvetage",
    },
    // answers: ["2.41","2.49"]
    answers: ["2.2", "2.41", "2.49"],
  },
  2.44: {
    text: {
      EN: "Total number of persons on board was {{NUMBER}}",
      IT: "Il numero totale di persone a bordo era {{NUMBER}}",
      FR: "Le nombre total de personnes à bord était de {{NUMBER}}",
    },
    params: [
      {
        name: "NUMBER",
        type: "NUMBER",
        min: 0,
      },
    ],
    // answers: ["2.41"]
    answers: ["2.2", "2.41", "2.49"],
  },
  2.45: {
    text: {
      EN: "All persons rescued",
      IT: "Tutte le persone soccorse",
      FR: "Toutes les personnes secourues",
    },
    // answers: ["2.41","2.49"]
    answers: ["2.2", "2.41", "2.49"],
  },
  2.46: {
    text: {
      EN: "{{NUMBER}} persons rescued",
      IT: "{{NUMBER}} persone soccorse",
      FR: "{{NUMBER}} personnes secourues",
    },
    params: [
      {
        name: "NUMBER",
        type: "NUMBER",
        min: 0,
      },
    ],
    // answers: ["2.41"]
    answers: ["2.2", "2.41", "2.49"],
  },
  2.47: {
    text: {
      EN: "You may stop search and proceed with voyage",
      IT: "Potete fermare le ricerche e procedere per il viaggio",
      FR: "Vous pouvez arrêter la recherche et poursuivre le voyage",
    },
    answers: [],
  },
  2.48: {
    text: {
      EN: "There is no hope to rescue more persons",
      IT: "Non c’è più speranza di soccorrere altre persone",
      FR: "Il n'y a aucun espoir de sauver plus de personnes",
    },
    answers: ["2.49"],
  },
  2.49: {
    text: {
      EN: "We finish with SAR operations",
      IT: "Noi finiamo le operazioni SAR",
      FR: "Nous terminons avec les opérations SAR",
    },
    answers: [],
  },
  "2.50": {
    text: {
      EN: "MV {{BOAT_NAME}} has lost person(s) overboard in position {{POSITION}}",
      IT: "Motonave {{BOAT_NAME}} ha perso una persona/e fuoribordo in posizione {{POSITION}}",
      FR: "MV {{BOAT_NAME}} a perdu une ou plusieurs personnes par-dessus bord en position {{POSITION}}",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: ["2.53", "2.54", "2.55", "2.56", "2.59"],
  },
  2.51: {
    text: {
      EN: "Assist with search in vicinity of position {{POSITION}}",
      IT: "Assistere con ricerche in vicinanza della posizione {{POSITION}}",
      FR: "Aide à la recherche à proximité de la position {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: ["2.53", "2.54", "2.55", "2.58", "2.59", "2.60"],
  },
  2.52: {
    text: {
      EN: "All vessels in vicinity of position {{POSITION}} keep sharp lookout and report to {{VESSEL}}",
      IT: "Tutte le navi in prossimità della posizione {{POSITION}} prestino attenta vigilanza e riportino a {{VESSEL}}",
      FR: "Tous les navires à proximité de la position {{POSITION}} restent vigilants et se présentent à {{VESSEL}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
      {
        name: "VESSEL",
        type: "TEXT",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: ["2.53", "2.54", "2.55"],
  },
  2.53: {
    text: {
      EN: "MV {{BOAT_NAME}} is proceeding for assistance. ETA at {{HOUR}} UTC",
      IT: "Motonave {{BOAT_NAME}} sta procedendo per assistenza. Tempo stimato di arrivo alle ore {{HOUR}} UTC",
      FR: "MV {{BOAT_NAME}} procède à l'assistance. ETA à {{HOUR}} UTC",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
      {
        name: "HOUR",
        type: "TEXT",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: ["2.51", "2.54", "2.55", "2.58", "2.59", "2.60"],
  },
  2.54: {
    text: {
      EN: "Search in vicinity of position {{POSITION}}",
      IT: "Ricerca in vicinanza della posizione {{POSITION}}",
      FR: "Recherche à proximité de la position {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: ["2.55", "2.58", "2.59", "2.60"],
  },
  2.55: {
    text: {
      EN: "MV {{BOAT_NAME}} is searching in vicinity of position {{POSITION}}",
      IT: "Motonave {{BOAT_NAME}} sta cercando in prossimità della posizione {{POSITION}}",
      FR: "MV {{BOAT_NAME}} recherche à proximité de la position {{POSITION}}",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: ["2.51", "2.54", "2.53", "2.58", "2.59", "2.60"],
  },
  2.56: {
    text: {
      EN: "Aircraft ETA at {{HOUR}} UTC to assist in search",
      IT: "Ora di previsto arrivo di un aereo alle ore {{HOUR}} UTC per assistere alla ricerche",
      FR: "ETA de l'avion à {{HOUR}} UTC pour faciliter la recherche",
    },
    params: [
      {
        name: "HOUR",
        type: "TEXT",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: [],
  },
  2.57: {
    text: {
      EN: "Can you continue search?",
      IT: "Puoi continuare le ricerche?",
      FR: "Pouvez-vous continuer la recherche ?",
    },
    answers: ["2.57.1", "2.57.2"],
  },
  "2.57.1": {
    text: {
      EN: "Yes, I can continue search",
      IT: "Si io posso continuare le ricerche",
      FR: "Oui, je peux continuer la recherche",
    },
    answers: ["2.51", "2.54", "2.55", "2.58", "2.59", "2.60"],
  },
  "2.57.2": {
    text: {
      EN: "No, I cannot continue search",
      IT: "No, io non posso continuare le ricerche",
      FR: "Non, je ne peux pas continuer la recherche",
    },
    answers: ["2.51", "2.54", "2.55", "2.58", "2.59", "2.60"],
  },
  2.58: {
    text: {
      EN: "Stop search",
      IT: "Fermate le ricerche",
      FR: "Arrêtez les recherches",
    },
    answers: [],
  },
  2.59: {
    text: {
      EN: "Return to {{RETURN}}",
      IT: "Ritornate a {{RETURN}} ",
      FR: "Retour à {{RETURN}}",
    },
    params: [
      {
        name: "RETURN",
        type: "TEXT",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: [],
  },
  "2.60": {
    text: {
      EN: "Proceed with your voyage",
      IT: "Procedete nel vostro viaggio",
      FR: "Continuez votre voyage",
    },
    answers: [],
  },
  2.61: {
    text: {
      EN: "What is the result of search?",
      IT: "Qual’è il risultato delle ricerche?",
      FR: "Quel est le résultat de la recherche ?",
    },
    answers: ["2.61.1", "2.61.2"],
  },
  "2.61.1": {
    text: {
      EN: "The result of search is negative",
      IT: "Il risultato delle ricerche è negativo",
      FR: "Les résultats de la recherche sont négatifs",
    },
    answers: ["2.58", "2.59", "2.60"],
  },
  2.62: {
    text: {
      EN: "MV {{BOAT_NAME}} located / picked up person(s) in position {{POSITION}}",
      IT: "Motonave {{BOAT_NAME}} ha localizzato/recuperato persona/e in posizione {{POSITION}}",
      FR: "MV {{BOAT_NAME}} a localisé / récupéré une ou des personnes en position {{POSITION}}",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: ["2.53", "2.59", "2.64"],
  },
  2.63: {
    text: {
      EN: "Person picked up is crew member/passenger of MV {{VESSEL}}",
      IT: "Persona/e recuperate sono membri dell’equipaggio/passeggeri della Motonave {{VESSEL}}",
      FR: "La personne prise en charge est un membre d'équipage/passager du MV {{VESSEL}}",
    },
    params: [
      {
        name: "VESSEL",
        type: "TEXT",
      },
    ],
    // answers: ["2.2", "2.3", "2.4"]
    answers: ["2.53", "2.59", "2.64"],
  },
  2.64: {
    text: {
      EN: "What is condition of person(s)?",
      IT: "Quali sono le condizioni delle persone/a?",
      FR: "Quelle est la condition de la ou des personnes ?",
    },
    answers: ["2.64.1", "2.64.2"],
  },
  "2.64.1": {
    text: {
      EN: "Condition of person(s) {{CONDITION}}",
      IT: "Le condizioni delle persone/a sono {{CONDITION}}",
      FR: "État de la ou des personnes {{CONDITION}}",
    },
    params: [
      {
        name: "CONDITION",
        type: "SELECT",
        options: [
          {
            EN: "GOOD",
            IT: "BUONE",
            FR: "BIEN",
          },
          {
            EN: "BAD",
            IT: "CATTIVE",
            FR: "MAL",
          },
        ],
      },
    ],
    answers: ["2.53", "2.59"],
  },
  "2.64.2": {
    text: {
      EN: "Person(s) dead",
      IT: "Persona/e morta/e",
      FR: "Personne(s) décédée(s)",
    },
    answers: ["2.53", "2.59"],
  },
  3.1: {
    text: {
      EN: "Must I take tug(s)?",
      IT: "Devo prendere rimorchiatore/i?",
      FR: "Dois-je prendre des remorqueurs?",
    },
    answers: ["3.1.1", "3.1.2"],
  },
  "3.1.1": {
    text: {
      EN: "Yes, you must take {{TUGS}} tug(s)",
      IT: "Si, devi prendere {{TUGS}} rimorchiatore/i",
      FR: "Oui, vous devez prendre {{TUGS}} remorqueur(s)",
    },
    params: [
      {
        name: "TUGS",
        type: "NUMBER",
        min: 0,
      },
    ],
    answers: ["3.1", "3.2", "3.3"],
  },
  "3.1.2": {
    text: {
      EN: "No, you need not take tug(s)",
      IT: "No, non devi prendere rimorchiatore/i",
      FR: "Non, vous n'avez pas besoin de remorquer (s)",
    },
    answers: ["3.1", "3.2", "3.3"],
  },
  3.2: {
    text: {
      EN: "How many tugs must I take?",
      IT: "Quanti rimorchiatori devo prendere?",
      FR: "Combien de remorqueurs dois-je prendre ?",
    },
    answers: ["3.2.1", "3.2.2"],
  },
  "3.2.1": {
    text: {
      EN: "You must take {{TUGS}} tug(s) according to Port Regulations",
      IT: "Devi prendere {{TUGS}} rimorchiatori, in accordo con il regolamento portuale",
      FR: "Vous devez prendre {{TUGS}} remorqueur(s) conformément aux réglementations portuaires",
    },
    params: [
      {
        name: "TUGS",
        type: "NUMBER",
        min: 0,
      },
    ],
    answers: ["3.1", "3.2", "3.3"],
  },
  "3.2.2": {
    text: {
      EN: "You must take {{FORE}} tug(s) fore and {{AFT}} tug(s) aft",
      IT: "Devi prendere {{FORE}} rimorchiatori a prora e {{AFT}} rimorchiaotri a poppa",
      FR: "Vous devez prendre {{FORE}} remorqueur(s) à l'avant et {{AFT}} remorqueur(s) à l'arrière",
    },
    params: [
      {
        name: "FORE",
        type: "NUMBER",
        min: 0,
      },
      {
        name: "AFT",
        type: "NUMBER",
        min: 0,
      },
    ],
    answers: ["3.1", "3.2", "3.3"],
  },
  3.3: {
    text: {
      EN: "I require {{TUGS}} tug(s)",
      IT: "Richiedo {{TUGS}} rimorchiatore/i",
      FR: "J'ai besoin de {{TUGS}} remorqueur(s)",
    },
    params: [
      {
        name: "TUGS",
        type: "NUMBER",
        min: 0,
      },
    ],
    answers: [],
  },
  4.1: {
    text: {
      EN: "I am MV {{BOAT_NAME}} not under command",
      IT: "Sono la Motonave {{BOAT_NAME}} fuori governo",
      FR: "Je suis le MV {{BOAT_NAME}} non commandé",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["4.2"],
  },
  4.2: {
    text: {
      EN: "What problems do you have?",
      IT: "Che problemi avete?",
      FR: "Quels problèmes avez-vous ?",
    },
    answers: ["4.2.1"],
  },
  "4.2.1": {
    text: {
      EN: "MV {{BOAT_NAME}} has problems with {{PROBLEM}}",
      IT: "Motonave {{BOAT_NAME}} ha problemi con {{PROBLEM}}",
      FR: "Le MV {{BOAT_NAME}} a des problèmes avec {{PROBLEM}}",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
      {
        name: "PROBLEM",
        type: "SELECT",
        options: [
          {
            EN: "engine(s)",
            IT: "i motori",
            FR: "moteur(s)",
          },
          {
            EN: "steering gear",
            IT: "timoneria",
            FR: "l'appareil à gouverner",
          },
          {
            EN: "propeller",
            IT: "assi-eliche",
            FR: "hélice",
          },
        ],
      },
    ],
    answers: ["4.2"],
  },
  4.3: {
    text: {
      EN: "MV {{BOAT_NAME}} is manoeuvring with difficulty",
      IT: "Motonave {{BOAT_NAME}} manovro con difficoltà",
      FR: "Le MV {{BOAT_NAME}} manoeuvre difficilement",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["4.2"],
  },
  4.4: {
    text: {
      EN: "I am MV {{BOAT_NAME}}, keep clear of me",
      IT: "Sono la Motonave {{BOAT_NAME}}, state alla larga da me",
      FR: "Je suis le MV {{BOAT_NAME}}, restez à l'écart de moi",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["4.2"],
  },
  4.5: {
    text: {
      EN: "Navigate with caution",
      IT: "Navigare con cautela",
      FR: "Naviguez avec prudence",
    },
    answers: ["4.2"],
  },
  4.6: {
    text: {
      EN: "MV {{BOAT_NAME}} requires {{REQUEST}}",
      IT: "Motonave {{BOAT_NAME}} richiede {{REQUEST}}",
      FR: "Le MV {{BOAT_NAME}} nécessite {{REQUEST}}",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
      {
        name: "REQUEST",
        type: "SELECT",
        options: [
          {
            EN: "tug assistance",
            IT: "assistenza di un rimorchiatore",
            FR: "aide du remorqueur",
          },
          {
            EN: "escort",
            IT: "scorta",
            FR: "escorte",
          },
        ],
      },
    ],
    answers: ["4.2"],
  },
  4.7: {
    text: {
      EN: "MV {{BOAT_NAME}} tries to proceed without assistance",
      IT: "Motonave {{BOAT_NAME}} prova a procedere senza assistenza",
      FR: "Le MV {{BOAT_NAME}} essaie de continuer sans assistance",
    },
    params: [
      {
        name: "BOAT_NAME",
        type: "BOAT_INFO",
      },
    ],
    answers: ["4.2"],
  },
  4.8: {
    text: {
      EN: "Stand by on VHF Channel {{CHANNEL}}",
      IT: "Attendete sul canale {{CHANNEL}} VHF",
      FR: "Veille sur le canal VHF {{CHANNEL}}",
    },
    params: [
      {
        name: "CHANNEL",
        type: "NUMBER",
        min: 1,
        max: 88,
      },
    ],
    answers: ["4.8.1"],
  },
  "4.8.1": {
    text: {
      EN: "Standing by on VHF Channel {{CHANNEL}}",
      IT: "Attendo sul canale {{CHANNEL}} VHF",
      FR: "En attente sur le canal VHF {{CHANNEL}}",
    },
    params: [
      {
        name: "CHANNEL",
        type: "NUMBER",
        min: 1,
        max: 88,
      },
    ],
    answers: [],
  },
  5.1: {
    text: {
      EN: "Unknown object(s) in position {{POSITION}}",
      IT: "Oggetto(i) sconosciuto(i) in posizione {{POSITION}}",
      FR: "Objet(s) inconnu(s) en position {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  5.3: {
    text: {
      EN: "Unlit derelict vessel adrift in vicinity {{POSITION}} at {{DATE_TIME}} (date and time)",
      IT: "Nave alla deriva non illuminata in prossimità {{POSITION}} alle {{DATE_TIME}} (data e ora)",
      FR: "Navire abandonné non éclairé à la dérive à proximité de {{POSITION}} à {{DATE_TIME}} (date et heure)",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
      {
        name: "DATE_TIME",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  5.4: {
    text: {
      EN: "Dangerous wreck / obstruction located in position {{POSITION}} marked by {{TYPE}} (type) buoy",
      IT: "Relitto pericoloso / ostacolo localizzato in posizione {{POSITION}} segnalato da {{TYPE}} (tipo) boa",
      FR: "Épave/obstruction dangereuse située à la position {{POSITION}} marquée par la bouée {{TYPE}} (type)",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
      {
        name: "TYPE",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  5.5: {
    text: {
      EN: "Hazardous mine adrift in vicinity {{POSITION}} at {{DATE_TIME}} (date and time)",
      IT: "Mina pericolosa alla deriva in prossimità {{POSITION}} alle {{DATE_TIME}} (data e ora)",
      FR: "Mine dangereuse à la dérive à proximité de {{POSITION}} à {{DATE_TIME}} (date et heure)",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
      {
        name: "DATE_TIME",
        type: "TEXT",
      },
    ],
    answers: [],
  },
  5.6: {
    text: {
      EN: "Uncharted reef / rock / shoal reported in position {{POSITION}}",
      IT: "Barriera / scoglio / secca non segnalata sulla carta, riportata in posizione {{POSITION}}",
      FR: "Récif / rocher / haut-fond non cartographié signalé en position {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  5.7: {
    text: {
      EN: "Pipeline is leaking gas / oil in position {{POSITION}}. Wide berth requested",
      IT: "Conduttura con perdita di gas / idrocarburi in posizione {{POSITION}}. Ampio spazio di manovra richiesto",
      FR: "Le pipeline fuit du gaz/pétrole en position {{POSITION}}. Large couchette demandée",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  5.8: {
    text: {
      EN: "Depth of water not sufficient in position {{POSITION}}",
      IT: "Profondità dell'acqua non sufficiente in posizione {{POSITION}}",
      FR: "Profondeur d'eau insuffisante en position {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  5.9: {
    text: {
      EN: "Navigation closed in area {{POSITION}}",
      IT: "Navigazione preclusa nell'area {{POSITION}}",
      FR: "Navigation fermée dans la zone {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
  6.1: {
    text: {
      EN: "It is dangerous {{DANGER}}",
      IT: "E' pericoloso {{DANGER}}",
      FR: "C'est dangereux {{DANGER}}",
    },
    params: [
      {
        name: "DANGER",
        type: "SELECT",
        options: [
          {
            EN: "to anchor in your present position",
            IT: "ancorare nella attuale posizione",
            FR: "pour ancrer dans votre position actuelle",
          },
          {
            EN: "to remain in your present position",
            IT: "rimanare nella attuale posizione",
            FR: "rester dans votre poste actuel",
          },
        ],
      },
    ],
    answers: [],
  },
  6.2: {
    text: {
      EN: "Large vessel is leaving the fairway - keep clear of the fairway approach",
      IT: "Una grande nave sta lasciando il canale - tenersi lontano dall'ingresso del canale",
      FR: "Un gros navire quitte le chenal - restez à l'écart de l'approche du chenal",
    },
    answers: [],
  },
  6.3: {
    text: {
      EN: "Nets with buoys / without buoys in this area - navigate with caution",
      IT: "Reti con boe / senza boe in quest'area - navigare con prudenza",
      FR: "Filets avec bouées / sans bouées dans cette zone - naviguer avec prudence",
    },
    answers: [],
  },
  6.4: {
    text: {
      EN: "Collision in position {{POSITION}}",
      IT: "Collisione in posizione {{POSITION}}",
      FR: "Collision en position {{POSITION}}",
    },
    params: [
      {
        name: "POSITION",
        type: "POSITION",
      },
    ],
    answers: [],
  },
};

const MAY_DAY = {
  id: "C1",
  children: [
    {
      id: "C1.1",
      children: [
        {
          id: "1.1",
        },
        {
          id: "1.1a",
        },
        {
          id: "1.5",
        },
      ],
    },
    {
      id: "C1.2",
      children: [
        {
          id: "C1.2.1",
          children: [
            {
              id: "2.1",
            },
            {
              id: "2.1.1",
            },
            {
              id: "2.5",
            },
            {
              id: "2.13",
            },
            {
              id: "2.14",
            },
          ],
        },
        {
          id: "C1.2.2",
          children: [
            {
              id: "2.15",
            },
            {
              id: "2.16",
            },
            {
              id: "2.17",
            },
          ],
        },
        {
          id: "C1.2.3",
          children: [
            {
              id: "2.18",
            },
            {
              id: "2.19",
            },
            {
              id: "2.20",
            },
            {
              id: "2.20.3",
            },
            {
              id: "2.22",
            },
            {
              id: "2.23",
            },
            {
              id: "2.24",
            },
            {
              id: "2.25",
            },
            {
              id: "2.26",
            },
            {
              id: "2.27",
            },
            {
              id: "2.28",
            },
            {
              id: "2.29",
            },
            {
              id: "2.30",
            },
            {
              id: "2.31",
            },
            {
              id: "2.32",
            },
            {
              id: "2.33",
            },
            {
              id: "2.35",
            },
          ],
        },
        {
          id: "C1.2.4",
          children: [
            {
              id: "2.34",
            },
            {
              id: "2.34.2",
            },
            {
              id: "2.35",
            },
            {
              id: "2.36",
            },
            {
              id: "2.37",
            },
            {
              id: "2.37.3",
            },
            {
              id: "2.37.4",
            },
            {
              id: "2.38",
            },
            {
              id: "2.38.1",
            },
            {
              id: "2.39",
            },
            {
              id: "2.40",
            },
            {
              id: "2.45",
            },
            {
              id: "2.46",
            },
            {
              id: "2.47",
            },
            {
              id: "2.49",
            },
          ],
        },
        {
          id: "C1.2.5",
          children: [
            {
              id: "2.50",
            },
            {
              id: "2.51",
            },
            {
              id: "2.52",
            },
            {
              id: "2.54",
            },
            {
              id: "2.55",
            },
            {
              id: "2.56",
            },
            {
              id: "2.58",
            },
            {
              id: "2.59",
            },
            {
              id: "2.60",
            },
            {
              id: "2.61",
            },
          ],
        },
      ],
    },
  ],
};

const PAN_PAN = {
  id: "C2",
  children: [
    {
      id: "C2.1",
      children: [
        {
          id: "3.1",
        },
        {
          id: "3.2",
        },
        {
          id: "3.3",
        },
      ],
    },
    {
      id: "C2.2",
      children: [
        {
          id: "4.1",
        },
        {
          id: "4.3",
        },
        {
          id: "4.4",
        },
        {
          id: "4.5",
        },
        {
          id: "4.6",
        },
        {
          id: "4.7",
        },
        {
          id: "4.8",
        },
      ],
    },
  ],
};

const SECURITE = {
  id: "C3",
  children: [
    {
      id: "C3.1",
      children: [
        {
          id: "5.1",
        },
        {
          id: "5.3",
        },
        {
          id: "5.4",
        },
        {
          id: "5.5",
        },
        {
          id: "5.6",
        },
        {
          id: "5.7",
        },
        {
          id: "5.8",
        },
        {
          id: "5.9",
        },
      ],
    },
    {
      id: "C3.2",
      children: [
        {
          id: "6.1",
        },
        {
          id: "6.2",
        },
        {
          id: "6.3",
        },
        {
          id: "6.4",
        },
      ],
    },
  ],
};

const NEW_MESSAGE_TREE = [
  MAY_DAY,
  PAN_PAN,
  SECURITE,
  {
    id: "CUSTOM",
  },
];

module.exports = {
  MESSAGES,
  NEW_MESSAGE_TREE,
  MAY_DAY,
  PAN_PAN,
  SECURITE,
};
